export function AcqFooter({ config }) {
  const legalName = config?.seller_entity?.legal_name || 'A confirmar antes da publicação';
  return (
    <footer className="acq-footer">
      <div className="acq-container" style={{ display: 'grid', gap: '.75rem' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.5rem 1.5rem', justifyContent: 'space-between' }}>
          <div><strong>Liofilândia</strong> · Planeamento executivo · versão {config?.version || '—'}</div>
          <div>Entidade vendedora: <em>{legalName}</em></div>
        </div>
        <p style={{ margin: 0 }}>Este documento é confidencial. Não se destina a publicação. Todas as projeções são hipóteses não auditadas.</p>
        <p style={{ margin: 0 }}>Fontes de validação: <a href="https://www.oe.gov.pt/noticias/sabe-quais-sao-as-principais-novidades-fiscais-em-2026/" target="_blank" rel="noreferrer">IRC 2026</a> · <a href="https://www.ecb.europa.eu/home/html/index.en.html" target="_blank" rel="noreferrer">Câmbio ECB</a> · <a href="https://diariodarepublica.pt/dr/detalhe/decreto-lei/84-2021-172938301" target="_blank" rel="noreferrer">DL 84/2021 (garantia)</a> · <a href="https://diariodarepublica.pt/dr/detalhe/decreto-lei/24-2014-572450" target="_blank" rel="noreferrer">DL 24/2014 (livre resolução)</a>.</p>
      </div>
    </footer>
  );
}
